module.exports = __webpack_public_path__ + "img/Meeting.6a96a504.svg";